<script setup lang="ts">
import type { CmsElementBioCircle } from "~/composables/useCustom";
import SharedHeadline from "~/components/shared/SharedHeadline.vue";
import SharedTopline from "~/components/shared/SharedTopline.vue";

const props = defineProps<{
  content: CmsElementBioCircle;
}>();

const {
  toplineText,
  toplineType,
  headlineText,
  headlineType,
  Boxes,
  mainText,
} = props.content.data;
</script>
<template>
  <section class="team_section prose-p:text-sm prose-h3:mb-7 prose-h6:text-base text-sm">
    <div class="container">
      <div class="mb-10 lg:mb-[3.75rem]" v-if="toplineText || headlineText">
        <SharedTopline
          :headline="toplineText"
          :headlineType="toplineType"
        ></SharedTopline>
        <SharedHeadline
          :headline="headlineText"
          :headlineType="headlineType"
        ></SharedHeadline>
      </div>

      <article class="bg-skin-white rounded p-10 mb-7 prose-h4:text-base prose-h4:mb-5">
        <div class="w-full mb-5">
          <div v-html="mainText"></div>
        </div>
        <div
          class="grid -mx-2.5 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 laptop:grid-cols-4 gap-5 gap-x-0 prose-p:mt-1 prose-a:underline"
        >
          <template v-for="(item, index) in Boxes" :key="index">
            <div class="w-full grid-item p-2.5">
              <div class="bg-skin-icon rounded-10 p-5 h-full">
                <figure class="eql mb-5 min-h-[10rem] bg-skin-white rounded flex">
                  <NuxtImg
                    v-if="item.boxImage && item.boxImage.media"
                    :src="item.boxImage.media.url"
                    format="webp"
                    alt=""
                    class="rounded object-cover w-full"
                    width="207"
                    height="207"
                  />
                </figure>
                <h6 class="font-normal font-sm" v-html="item.boxText"></h6>
                <small v-html="item.boxCanton"></small>
                <p v-html="item.boxPosition"></p>
                <p><a :href="'mailto:' + item.boxEmail" v-html="item.boxEmail"></a></p>
                <p><a :href="'tel:' + item.boxTel" v-html="item.boxTel"></a></p>
              </div>
            </div>
          </template>
        </div>
      </article>
    </div>
  </section>
</template>
